import {ChangeDetectorRef, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {OptionComponent} from "./option.component";
import {Option} from "./option";
import {NavigationService} from "../../orchestration/navigation.service";
import {TranslateService} from "ng2-translate";

@Component({
    selector: "woa-selection-field",
    templateUrl: "./selection-field.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: SelectionFieldComponent, multi: true}]
})
export class SelectionFieldComponent extends AbstractField {
    @Input() optionsTitle: string;
    @Input() noMessage: boolean = false;
    @Input() showMessageSpinner: boolean = false;
    @Input() toggleActive: boolean = false;
    @Input() showNone: boolean = true;

    @Output() onActivateField: EventEmitter<void> = new EventEmitter();

    @ContentChildren(OptionComponent) private optionComponents: QueryList<OptionComponent>;

    private selectedOption: Option;

    constructor(changeDetectorRef: ChangeDetectorRef,
                private translate: TranslateService,
                private navigationService: NavigationService) {
        super(changeDetectorRef);
    }

    writeValue(value: any) {
        super.writeValue(value);
        const options: Option[] = this.options;
        this.selectedOption = options ? options.find((option: Option) => option.value === value) : undefined;
    }

    async activated(): Promise<void> {
        if (this.readOnly) {
            return;
        }

        this.onActivateField.emit();
        if (this.optionComponents.length) {
            const option: Option = await this.navigationService.createPage("woa-options-page", {
                title: this.optionsTitle || this.label,
                translationParams: this.translationParams,
                options: this.options,
                showNone: this.showNone
            });
            if (option !== undefined) {
                this.selectedOption = option;
                this.value = option ? option.value : null;
            }
        }
    }

    private get options(): Option[] {
        return this.optionComponents ? this.optionComponents.map((optionComponent: OptionComponent) => optionComponent.option) : undefined;
    }

    get displayValue(): any {
        return this.selectedOption && this.selectedOption.label && this.value != undefined ? this.translate.instant(this.selectedOption.label, {value: this.value}) : this.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/selection-field.component.ts